import React from "react";
import { useMediaQuery } from "@mui/material";

function SelectOption(props) {
  const { label, value, onSelect, isSelected, width, isReadonly, note } = props;
  const isMd = useMediaQuery("(min-width:768px)");

  const handleClick = () => {
    if(isReadonly) return;
    onSelect(value);
  };
  return (
    <div className={isMd ? "flex" : ''}>
      <button
        type="button"
        onClick={handleClick}
        className={`h-[30px] flex items-center justify-center text-[10px] leading-3 font-noto-sans-jp rounded-full px-2 text-white ${
          isSelected ? "bg-[#dc5553]" : "bg-[#eda9a9]"
        } ${isReadonly ? "cursor-default" : "cursor-pointer"}`}
        style={{
          width: width || "100%",
        }}
        disabled={isReadonly}
      >
        {label}
      </button>
      {note && (
        <div className="flex-1 p-2 text-xs text-[#707070]">
          {note}
        </div>
      )}
    </div>
  );
}

export default SelectOption;
